module.exports = __webpack_public_path__ + "img/jia.1feb7757.png";